import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/admin/FeaturedEpisodesManager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/layout/main.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ServiceWorkerRegistration.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/vercel/path0/contexts/language-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SavedWordsProvider"] */ "/vercel/path0/contexts/saved-words-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SubscriptionProvider"] */ "/vercel/path0/contexts/subscription-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UsageProvider"] */ "/vercel/path0/contexts/usage-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserSettingsProvider"] */ "/vercel/path0/contexts/user-settings-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserProvider"] */ "/vercel/path0/lib/context/user-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SWRProvider"] */ "/vercel/path0/lib/swr-config.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.16_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.16_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/node_modules/.pnpm/sonner@2.0.3_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/sonner/dist/index.mjs");
